// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
export default 'in highp float v_elevation;void main() {fragColor=vec4(v_elevation,0.0,0.0,1.0);}';
